// ** React Imports
import {useEffect, useState, Fragment} from 'react'
import {Link} from 'react-router-dom'

// ** Custom Components
import Avatar from '@components/avatar'

// ** Utils
import {isUserLoggedIn} from '@utils'

// ** Store & Actions
import {useDispatch} from 'react-redux'
import {handleLogout} from '@store/actions/auth'

// ** Third Party Components
import {UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem} from 'reactstrap'
import {User, Mail, CheckSquare, MessageSquare, Settings, CreditCard, HelpCircle, Power} from 'react-feather'

// ** Default Avatar Image
import defaultAvatar from '@src/assets/images/portrait/small/avatar-s-11.jpg'
import {getUserData} from "../../../../auth/utils";

const UserDropdown = () => {
    // ** Store Vars
    const dispatch = useDispatch()
    

    let userObj = getUserData();
    if (!userObj || !userObj.userData) {
        return null
    }
    const userAvatar = userObj.userData.profilePhoto
    let myRole = [];
    if (userObj && userObj.userData.role) {
        myRole = [...new Set(userObj.userData.role)]
    }
    return (
        <UncontrolledDropdown tag='li' className='dropdown-user nav-item'>
            <DropdownToggle href='/' tag='a' className='nav-link dropdown-user-link' onClick={e => e.preventDefault()}>
                <div className='user-nav d-sm-flex d-none'>
                    <span className='user-name font-weight-bold'>{(userObj.userData.email)}</span>
                    <span className='user-status'>
            {myRole.map((oneRole) => {
                if (oneRole == "user" || true) {
                    return null
                }
                return (
                    <Fragment>
                        {oneRole} &nbsp;
                    </Fragment>
                );
            })
            }
          </span>
                </div>
                <Avatar img={userAvatar} imgHeight='40' imgWidth='40' status='online'/>
            </DropdownToggle>
            <DropdownMenu right>
            {myRole.map((oneRole) => {
                    if (oneRole === "user") {
                        return null
                    }
                    return (
                        <DropdownItem style={{cursor: "auto", marginBottom: "3px"}} className="select__multi-value mx-auto">
                            <span>{oneRole}</span>
                        </DropdownItem>
                    );
                })}
                  <hr/>
                <DropdownItem tag={Link} to='/korisnicki-profil'>
                    <span className='align-middle'>Profil</span>
                </DropdownItem>
                <DropdownItem tag={Link} to='/login' onClick={() => dispatch(handleLogout())}>
                    <span className='align-middle'>Odjava</span>
                </DropdownItem>
              
               
            </DropdownMenu>
        </UncontrolledDropdown>
    )
}

export default UserDropdown
